import { TRACKING_PLATFORM_TYPES } from '@vfde-fe/ngx-lib/plugins/tracking';


/** Tracking default data */
export const TRACKING_DEFAULT = {
  siteArea: 'service',
  pageType: 'self service',
  loginStatus: 'not logged in',
  platformType: TRACKING_PLATFORM_TYPES.RESPONSIVE,
  defaultMessage: 'Das hat leider nicht geklappt',
};

/** TrackingErrorType is enum which decripe types of tracking errors */
export enum TrackingErrorType {
  technical = 'technical',
  validation = 'validation',
  authentication = 'authentication',
}
/** form name to  */
export const FORM_CENTER_NAME = 'form center ';

/** Tracking form setting for each form in the app */
export const TRACKING_FORM = {
    CENTERHUB: {
    siteStructure: ["privatkunden", "hilfe", "form center"],
    loginStatus: "not logged in",
    pageType: "self service",
    siteArea: "service",
    platformType:  TRACKING_PLATFORM_TYPES.RESPONSIVE,
  },

  FORMEDITOR: {
    oForm: {
      FORM_NAME: '{{name}}',
      FORM_STEP1: '1',
      FORM_STEP2: '2',
      START_FORM_STEP_NAME: 'start',
      CONFIRMATION_FORM_STEP_NAME: 'confirmation',
      START: {
        STATUS: ['start'],
      },
      SUCCESS: {
        STATUS: ['end', 'success'],
      },
      FAILURE: {
        STATUS: ['end', 'failure'],
      },
    },
    LOGIN_STATUS: TRACKING_DEFAULT.loginStatus,
    PAGE_TYPE: 'self service',
    FORM_TYPE: 'application funnel',
    SITE_AREA: 'service',
    PLATFORM_TYPE: TRACKING_PLATFORM_TYPES.RESPONSIVE,
    START_SITE_STRUCTURE: ["privatkunden", "hilfe", "form center", "1", "start"],
    CONFIRMATION_SITE_STRUCTURE: ["privatkunden", "hilfe", "form center", "2", "confirmation"],
  },
}

